export const DEFAULT_GRPS = [
  MACROS.DVM.DVM_GRP_LOGGING_OID,
  MACROS.DVM.DVM_GRP_MANAGED_OID,
  MACROS.DVM.DVM_GRP_UNREG_OID,
];
